import clsx from "clsx";
import React from "react";
import styles from "./ShipDirectionIcon.module.scss";

type Props = {
  variant: "horizontal" | "vertical";
  sternLabel: string;
  bowLabel: string;
  className?: string;
};

export const ShipDirectionIcon: React.FC<React.PropsWithChildren<Props>> = ({
  sternLabel,
  bowLabel,
  className,
  variant
}) => {
  return (
    <div
      className={clsx(styles.container, className, {
        [styles.horizontal]: variant == "horizontal",
        [styles.vertical]: variant == "vertical"
      })}
    >
      <span>{sternLabel}</span>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.5093 4.55242C26.2183 9.2568 26.1357 16.7398 21.4267 21.4442C16.6901 26.1761 9.28235 26.1761 4.57334 21.4992C-0.135676 16.7948 -0.218291 9.22929 4.49073 4.52491C9.22728 -0.206978 16.8003 -0.151955 21.5093 4.55242Z"
          stroke="#646468"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 12.8659L13.0255 10.0003L4 13.4928L13 16.0003L22 12.8659Z"
          stroke="#646468"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9648 12.25C13.3934 12.25 13.7148 12.5714 13.7148 13C13.7148 13.4286 13.3666 13.75 12.9648 13.75C12.5631 13.75 12.2148 13.4018 12.2148 13C12.2148 12.5982 12.5631 12.25 12.9648 12.25Z"
          stroke="#646468"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </svg>
      <span>{bowLabel}</span>
    </div>
  );
};
